import $ from 'jquery'

$(document).ready(function() {
	//Internal Nav
	const $internalMenu = $('#internal-menu')

	$('#internal-nav')
		.find('.section-name')
		.on('click', function() {
			$internalMenu.toggleClass('is-active')
		})

	//Add "page_item_has_children" class
	$internalMenu.find('>li').each(function() {
		if ($(this).find('.children').length) {
			$(this).addClass('page_item_has_children')
		}
	})

	//Internal nav dropdown menu in mobile/tablet views;
	$internalMenu.find('.page_item_has_children').on('click', function(e) {
		if ($(window).width() > 1023) {
			//Do the default thing;
		} else {
			if ($(this).hasClass('is-active')) {
				//Do the default thing;
			} else {
				//Just show the submenu and do not jump;
				e.preventDefault()
				$(this)
					.addClass('is-active')
					.siblings()
					.removeClass('is-active')
			}
		}
	})
})
